import { Link } from "react-router-dom";
import { Logo } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";

export default function PublicHeader() {
  const { user } = useAuth();
  return (
    <header className="w-full bg-white border-b border-[#F0EAF7] mb-8">
    <div className="max-w-6xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
      <Link to="/" data-testid="public-header-logo"><Logo /></Link>
      <nav className="flex items-center gap-5 text-xs uppercase tracking-[0.15em]">
        <Link to="/pricing" className="muted hover:text-[#1A1325] hidden sm:inline" data-testid="public-header-pricing-link">Pricing</Link>
        {user ? (
          <Link to="/" className="btn-secondary py-2 px-5" data-testid="public-header-studio-link">Studio</Link>
        ) : (
          <Link to="/login" className="btn-secondary py-2 px-5" data-testid="public-header-login-link">Sign in</Link>
        )}
      </nav>
    </div>
    </header>
  );
}

export const Footer = () => (
  <footer className="bg-white border-t border-[#F0EAF7] mt-24 py-10 text-center text-xs muted" data-testid="site-footer">
    © Certified Muse Studio · by On Deck Media
  </footer>
);
